<template>
  <div class="service-provided-container">
    <div class="service-provided-block">
      <img :src="require(`@/assets/img/lock.svg`)" alt />
      <div class="service-provided-block__content">
        <h4 class="service-provided-block__content__title">Услуга оказана?</h4>
        <span class="service-provided-block__content__description"
          >Подтвердите факт получения товара или услуги</span
        >
      </div>

      <div class="service-provided-block__radio">
        <v-radio-group :value="value" @change="$emit('input', $event)">
          <v-radio :key="true" label="Оказана" :value="true"></v-radio>
          <v-radio :key="false" label="Не оказана" :value="false"></v-radio>
        </v-radio-group>
      </div>
    </div>
    <span class="service-provided-container__description">
      Безопасно получите услугу или товар. Если услуга ещё не оказана, то ваши средства
      будут перечислены на транзитный счёт и поступят самозанятому по факту оказания
      услуги.
    </span>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss">
$primary: #1b559e;

.service-provided-block {
  display: flex;
  align-items: center;

  flex-direction: column;

  gap: 8px;
  padding: 8px 16px;

  border-radius: 8px;

  background: #fff;

  &__radio {
    margin-top: 16px;

    width: 100%;

    .v-input--selection-controls {
      margin: 0;
      padding: 0;
    }
  }

  &__content {
    display: flex;

    flex-direction: column;

    gap: 8px;

    width: 100%;

    &__title {
      font-weight: 700;
      font-style: Bold;
      font-size: 18px;

      line-height: 100%;
      letter-spacing: 0%;

      color: $primary;
    }

    &__description {
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
    }
  }
}

.service-provided-container {
  display: flex;
  flex-direction: column;

  gap: 16px;

  &__description {
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;

    color: #838a99;
  }
}
</style>
